import {Modal, Row, Col, Checkbox, List, Switch, Select, Space} from 'antd';
import React, {useState} from 'react';
import {useAppDispatch, useAppSelector} from '../../common/hooks';
import {CloseOutlined} from '@ant-design/icons';
import {UPDATE_COLUMNS} from './liveBatteries.type';
import {liveBatteriesColoumnUpdate, liveBatteriesConfig} from './liveBatteriesSlice';

const CustomColumnModal = ({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const tableColumns = useAppSelector((state) => state.liveBatteries.config);
  const dispatch = useAppDispatch();
  const [selectedCols, setSelectedCols] = useState(tableColumns.employee_column_list);
  const [autoRefresh, setAutoRefresh] = useState({active: true, delay_millis: 60000});

  const handleCheckbox = (key: string) => {
    if (selectedCols.some((x) => x.key === key)) {
      setSelectedCols((prevState) => {
        const newState = prevState.filter((x) => x.key !== key);
        return newState;
      });
    } else {
      tableColumns.full_column_list.map((x) => {
        if (x.key === key) {
          setSelectedCols((prevState) => {
            const newState = new Set(prevState);
            newState.add(x);
            const state = Array.from(newState);
            return state;
          });
        }
      });
    }
  };
  const handleCloseClick = (key: string) => {
    setSelectedCols((prevState) => {
      const newState = prevState.filter((x) => x.key !== key);
      return newState;
    });
  };

  const handleSubmit = () => {
    const list = Array.from(selectedCols.map((x) => x.key));
    const payload: UPDATE_COLUMNS = {
      column_list: list,
      auto_refresh: {enabled: autoRefresh.active, delay_millis: autoRefresh.delay_millis},
    };
    dispatch(liveBatteriesColoumnUpdate(payload))
      .unwrap()
      .then(() => {
        setIsOpen(false);
        dispatch(liveBatteriesConfig());
      });
  };

  return (
    <Modal
      title='Customize Table Columns'
      open={isOpen}
      onCancel={() => {
        setIsOpen(false);
      }}
      destroyOnClose={true}
      okText='Submit'
      onOk={handleSubmit}
      width={1000}
    >
      <Row style={{paddingBlock: '25px', border: '1px dashed #00000040', marginBottom: '10px'}}>
        <Col span={10} offset={1}>
          <h3>Total Columns</h3>
          <div style={{height: '200px', overflowY: 'auto'}}>
            {tableColumns.full_column_list.map((x) => {
              return (
                <Checkbox
                  key={x.key}
                  value={x.key}
                  checked={selectedCols.some((i) => i.key === x.key)}
                  disabled={x.key === 'soc' || x.key === 'asset_id'}
                  style={{width: '90%', marginLeft: '15px'}}
                  onChange={(e) => {
                    handleCheckbox(e.target.value);
                  }}
                >
                  {x.pretty_name}
                </Checkbox>
              );
            })}
          </div>
        </Col>
        <div
          style={{borderRight: '1px solid #00000050', height: 'auto', paddingInline: '2%'}}
        ></div>
        <Col span={10} offset={1}>
          <h3>Selected Columns</h3>
          <div style={{height: '200px', overflowY: 'auto'}}>
            {/* {selectedCols.map((x) => {
              
              return (
                <Tag key={x.key} style={{width: '90%', marginLeft: '15px'}} closable>
                  {x.pretty_name}
                </Tag>
              );
            })} */}
            <List
              dataSource={selectedCols}
              renderItem={(item) => (
                <List.Item
                  style={{
                    border: '1px solid #1890ff',
                    margin: '5px 10px',
                    padding: '5px 0px 5px 20px ',
                    borderRadius: '7px',
                  }}
                  key={item.key}
                  actions={[
                    item.key === 'soc' || item.key === 'asset_id' ? null : (
                      <CloseOutlined
                        style={{cursor: 'pointer', float: 'right', color: 'red'}}
                        key={item.key}
                        onClick={() => handleCloseClick(item.key)}
                      />
                    ),
                  ]}
                >
                  <div style={{width: '100%'}}>{item.pretty_name}</div>
                </List.Item>
              )}
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col offset={1}>
          <p>Auto refresh</p>
          <Space>
            <Switch
              checkedChildren='Active'
              unCheckedChildren='Inactive'
              defaultChecked={autoRefresh.active}
              onChange={(e) => {
                setAutoRefresh((prevState) => {
                  prevState.active = e;
                  return prevState;
                });
              }}
            />
            <Select
              style={{width: '200px'}}
              placeholder='Select time'
              defaultValue={autoRefresh.delay_millis ? autoRefresh.delay_millis : 120000}
              options={[
                {label: '30 Seconds', value: 30000},
                {label: '60 Seconds', value: 60000},
                {label: '90 Seconds', value: 90000},
                {label: '120 Seconds', value: 120000},
              ]}
              onChange={(e) => {
                setAutoRefresh((prevState) => {
                  prevState.delay_millis = e;
                  return prevState;
                });
              }}
            />
          </Space>
        </Col>
      </Row>
    </Modal>
  );
};

export default CustomColumnModal;
